import React from 'react';

const QuickLink = ({ navigation, company, handleNavSelector, index }) => {
    return (
        <>
            {company ?
                <>
                    <li onClick={() => handleNavSelector(index)} className="footer-link" >
                        <a className="  primary-text " href={navigation?.drop_nav7_link}>
                            {navigation?.drop_nav7}
                        </a>
                    </li>
                    <li onClick={() => handleNavSelector(index)} className="footer-link">
                        <a className="  primary-text " href={navigation?.drop_nav8_link}>
                            {navigation?.drop_nav8}
                        </a>
                    </li>
                </>
                :
                <li onClick={() => handleNavSelector(index)} className="footer-link" >
                    <a className="  primary-text " href={navigation?.drop_nav1_link}>
                        {navigation?.drop_nav1}
                    </a>
                </li>
            }
        </>
    );
};

export default QuickLink;